import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root"); // Устанавливаем корневой элемент

const PurchaseConfirmationModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                content: {
                    width: "300px",
                    height: '30%',
                    margin: "auto",
                    textAlign: "center",
                    borderRadius: "10px",
                    padding: "20px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)"
                }
            }}
        >
            <h2>Подтверждение покупки</h2>
            <p>Ваш заказ успешно оформлен!</p>
            <button onClick={onClose} style={{
                marginTop: "10px",
                padding: "10px 20px",
                border: "none",
                backgroundColor: "white",
                color: "#4CAF50",
                borderRadius: "5px",
                cursor: "pointer"
            }}>Закрыть</button>
        </Modal>
    );
};

export default PurchaseConfirmationModal;